var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_1340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3213 12.0426C13.9757 12.0426 15.4083 11.4492 16.5788 10.2785C17.7494 9.10793 18.3428 7.67571 18.3428 6.02109C18.3428 4.36705 17.7494 2.93463 16.5787 1.76372C15.4079 0.593374 13.9755 0 12.3213 0C10.6667 0 9.23444 0.593374 8.0639 1.76391C6.89337 2.93444 6.2998 4.36686 6.2998 6.02109C6.2998 7.67571 6.89337 9.10813 8.0641 10.2787C9.23482 11.449 10.6672 12.0426 12.3213 12.0426Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8578 19.2237C22.824 18.7366 22.7557 18.2052 22.6552 17.644C22.5537 17.0787 22.4231 16.5443 22.2667 16.0558C22.1051 15.5509 21.8854 15.0523 21.6138 14.5745C21.3319 14.0786 21.0008 13.6468 20.6292 13.2915C20.2407 12.9197 19.765 12.6209 19.2149 12.4028C18.6668 12.186 18.0593 12.0761 17.4095 12.0761C17.1543 12.0761 16.9074 12.1808 16.4308 12.4912C16.1374 12.6825 15.7943 12.9037 15.4113 13.1484C15.0838 13.3571 14.6402 13.5526 14.0922 13.7296C13.5576 13.9026 13.0147 13.9903 12.479 13.9903C11.9432 13.9903 11.4006 13.9026 10.8654 13.7296C10.318 13.5528 9.87431 13.3573 9.5472 13.1486C9.16783 12.9062 8.82451 12.6849 8.52678 12.491C8.0507 12.1806 7.8037 12.0759 7.5485 12.0759C6.89848 12.0759 6.29118 12.186 5.7432 12.403C5.19351 12.6207 4.71763 12.9195 4.32872 13.2917C3.95736 13.6472 3.62605 14.0788 3.34453 14.5745C3.07312 15.0523 2.85339 15.5507 2.69165 16.056C2.53544 16.5444 2.40478 17.0787 2.30331 17.644C2.2028 18.2044 2.13451 18.736 2.10075 19.2243C2.06757 19.7026 2.05078 20.1991 2.05078 20.7005C2.05078 22.0055 2.46563 23.062 3.28369 23.8412C4.09164 24.61 5.1607 25.0001 6.46074 25.0001H18.4984C19.7984 25.0001 20.8671 24.6102 21.6752 23.8412C22.4935 23.0626 22.9083 22.0059 22.9083 20.7004C22.9081 20.1966 22.8912 19.6998 22.8578 19.2237Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_1340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9999,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.123b9fa53dcee8831e69ef4c9f4491af.svg";
export { ForwardRef as ReactComponent };